import '../scss/main.scss';
import CarouselSlider from './carousel';

window.addEventListener('DOMContentLoaded', function(){
	let sliderContainers = document.querySelectorAll('.mslider-wrapper');

	if (sliderContainers.length < 1) {
		return;
	}

	sliderContainers = [].slice.call(sliderContainers);

	sliderContainers.forEach( container => {
		new CarouselSlider(container, [], container.querySelector('.mslider-container'), container.querySelector('.mslider-pagedots-container'));
	});
});